export {default as default} from './LandingsTitle'
